import { DATA_EXPORT_NAME } from ".";
import ConditionalRender from "../../../ConditionalRender";
import AnPopup from "../../cta_utils/AnPopup";

const ExportAppliedTags = ({
    handleOnClosePopup,
    data_export
}) => {
    return (
        <AnPopup name="exportAppliedTagsPopup" handleOnClosePopup={handleOnClosePopup} maxWidth={480}>
            <div className="text_title" style={{ marginBottom: 4 }}>{DATA_EXPORT_NAME[data_export.type] || data_export.name}</div>
            <div className="text_subtitle_light">{data_export.created_time}</div>
            <div className="line_seperator_ex_light_grey" style={{ margin: "8px auto" }}></div>
            <ConditionalRender if={data_export.name}>
                <div className="text_subtitle_big" style={{marginBottom: 12}}><span style={{fontWeight: 400}}>List Name: </span>{data_export.name}</div>
            </ConditionalRender>
            <div style={{ marginTop: 8 }}>
                {
                    data_export.tags?.length > 0 ?
                        <div>
                            <div className="text_subtitle_light" style={{marginBottom: 8}}>Filters applied</div>
                            {data_export.tags.map((tag, index) => {
                                return (
                                    <div key={index} className="text_subtitle_big export_tag">
                                        <span style={{ fontWeight: 400, whiteSpace: 'nowrap' }}>{tag.label}:&nbsp;</span>
                                        <span>{tag.value}</span>
                                    </div>
                                )
                            })}</div> :
                        <div>
                            <div className="text_subtitle_light">No Filters applied</div>
                        </div>
                }
            </div>
        </AnPopup>
    )
}
export default ExportAppliedTags